import { Font, StyleSheet } from "@react-pdf/renderer";
import { colors } from "@styles/vars";

Font.register({ family: 'Open Sans', src: 'https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFVZ0e.ttf', fontWeight: 400 })
Font.register({ family: 'Open Sans', src: 'https://fonts.gstatic.com/s/opensans/v13/k3k702ZOKiLJc3WVjuplzNqQynqKV_9Plp7mupa0S4g.ttf', fontWeight: 700 })

export default StyleSheet.create({
    h1: {
        fontFamily: 'Open Sans',
        fontWeight: 700,
        letterSpacing: '-1px',
        fontSize: '64px',
        lineHeight: 1,
        color: colors.black
    },
    h2: {
        fontFamily: 'Open Sans',
        fontWeight: 700,
        letterSpacing: '-1px',
        fontSize: '48px',
        lineHeight: 1.2,
        color: colors.black
    },
    h3: {
        fontFamily: 'Open Sans',
        fontWeight: 700,
        letterSpacing: '-1px',
        fontSize: '24px',
        lineHeight: 1.2,
        color: colors.black
    },
    p: {
        fontSize: '16px',
        lineHeight: 1.5
    },
    sm: {
        fontSize: '12px',
        lineHeight: 1.5
    },
    mgl15: {
        marginLeft: '15px'
    },
    mgb5: {
        marginBottom: '5px'
    },
    mgb10: {
        marginBottom: '10px'
    },
    mgb15: {
        marginBottom: '15px'
    },
    mgb20: {
        marginBottom: '30px'
    },
    mgb30: {
        marginBottom: '30px'
    },
    bold: {
        fontWeight: 700,
        color: colors.black
    },
    hr: {
        height: '1px',
        width: '100%',
        backgroundColor: colors.border,
        marginTop: '5px',
        marginBottom: '5px'
    },
    page: {
        backgroundColor: colors.white,
        color: colors.darkGrey,
        fontFamily: 'Open Sans',
        fontWeight: 400,
        padding: '30px'
    },
    column50left: {
        width: "50%",
        paddingRight: "15px"
    },
    column50right: {
        width: "50%",
        paddingLeft: "15px"
    },
    container: {
        padding: '30px',
        border: '1px solid ' + colors.border,
        borderRadius: '20px',
        backgroundColor: '#fff',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between'
    }
})